import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ServiceStatus } from "../models/auto-generated";

@Injectable({
  providedIn: "root"
})
export class ReplicationService {
  private getBaseRoute = (instanceId: string) => `/api/configurations/${instanceId}/replication`;
  constructor(private http: HttpClient) {}

  getStatus(instanceId: string): Observable<ServiceStatus> {
    return this.http.get<ServiceStatus>(`${this.getBaseRoute(instanceId)}/status`);
  }

  start(instanceId: string): Observable<void> {
    return this.http.post<any>(`${this.getBaseRoute(instanceId)}/start`, {});
  }

  stop(instanceId: string): Observable<void> {
    return this.http.post<any>(`${this.getBaseRoute(instanceId)}/stop`, {});
  }
}
